import React from 'react';
import {
    View,
    TextInput,
    StyleSheet,
    Alert,
    Dimensions
} from 'react-native';
import { connect } from 'react-redux';

import Colors from '../../constants/Colors';
import {ButtonWithSpinner, Button, ButtonImageText, InformationDialogue} from '../../components';
import post from "../../api/methods/post";
import {COMMENT_POST} from "./api/muralEndpoints";
import NavBar from "../../components/NavBar";

class CommentWriteScreen extends React.Component {

    state = {
        isSending: false,
        postText: "",
        imageData: null,

        showSuccessModal: false,
        showErrorModal: false,
    };

    handlePostSend = async () => {

        if (this.state.isSending) return;
        this.setState({ isSending: true });

        try {
            const { userId, userName, avatarColor, authToken } = this.props;
            const answerToId = this.props.location.state.answerToId;

            const body = {
                creatorId: userId,
                creatorName: userName,
                creatorAvatarColor: avatarColor,
                postText: this.state.postText,
                postImage: this.state.imageData,
                answerTo: answerToId
            };

            let result = await post(COMMENT_POST, body, this.props.authToken);
            this.setState({ showSuccessModal: true })
        } catch (e) {
            console.log('error sending comment');
            console.log(e);
            this.setState({ showErrorModal: true, })
        }

        this.setState({ isSending: false });
    };

    handleImageResponse = (response) => {
        if (!response.didCancel && !response.error) {
            this.setState({ imageData: response.data });
        }
    };

    render() {


        const { height } = Dimensions.get('window');

        return (
            <NavBar title={"Comentário"}>

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"Seu comentário foi enviado com sucesso!"}
                    onClose={() => this.props.history.goBack()}
                />

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={"Não conseguimos enviar o seu comentário! Tente novamente mais tarde!"}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <View style={{width: 600, alignItems: 'center'}} >

                    <View style={{
                        width: '90%',
                        minHeight: 200,
                        backgroundColor: 'white',
                        marginTop: 20,
                    }}>
                        <View style={{flex: 2, borderWidth: 1, borderColor: Colors.borderColor}}>
                            <TextInput
                                editable={true}
                                maxLength={280}
                                multiline
                                placeholder='Escreva seu comentário'
                                style={{flex: 1, padding: 20, textAlignVertical: 'top'}}
                                onChangeText={(newText) => this.setState({ postText: newText })}
                                value={this.state.postText}
                            />
                            {/*{*/}
                            {/*    this.state.keyboardShow === false &&*/}
                            {/*    <ButtonImageText*/}
                            {/*        text={'Enviar Foto/Imagem'}*/}
                            {/*        onPress={this.openDialog}*/}
                            {/*        imageSrc={require('./img/PhotoIcon.png')}*/}
                            {/*        propsContainerStyle={{maxHeight: 80}}*/}
                            {/*        propsTextStyle={{color: 'black', fontSize: 20, fontWeight: 'normal'}}*/}
                            {/*        propsImageStyle={{tintColor: Colors.buttonColor}}*/}
                            {/*    />*/}
                            {/*}*/}
                            {/*{*/}
                            {/*    (this.state.imageData != null && this.state.keyboardShow === false) &&*/}

                            {/*    <TouchableOpacity*/}
                            {/*        onPress={() => this.setState({ imageData: null })}*/}
                            {/*        style={{*/}
                            {/*            width: '100%',*/}
                            {/*            // backgroundColor: 'red',*/}
                            {/*            justifyContent: 'center',*/}
                            {/*            alignItems: 'center',*/}
                            {/*            padding: 10*/}
                            {/*        }}*/}
                            {/*    >*/}
                            {/*        <Text>*/}
                            {/*            { 'Clique para deletar a imagem.' }*/}
                            {/*        </Text>*/}
                            {/*        <Image*/}
                            {/*            source={{ uri: 'data:image/jpeg;base64,' + this.state.imageData }}*/}
                            {/*            style={{ width: 128, height: 128 }}*/}
                            {/*            resizeMode={'contain'}*/}
                            {/*        />*/}
                            {/*    </TouchableOpacity>*/}
                            {/*}*/}
                        </View>
                    </View>

                    <ButtonWithSpinner
                        isLoading={this.state.isSending}
                        size={'large'}
                        text={'Enviar'}
                        onPress={() => this.handlePostSend()}
                        containerPropsStyle={styles.sendButtonContainerPropsStyle}
                    />

                </View>

            </NavBar>
        )
    }
}

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        backgroundColor: Colors.backgroundColor,
    },
    sendButtonContainerPropsStyle: {
        marginRight: 20,
        marginLeft: 20,
        marginBottom: 10,
        marginTop: 10,
        backgroundColor: Colors.buttonColor,
        borderColor: Colors.buttonColor,
        height: 40,
        borderRadius: 8
    }
});

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        userName: state.user.userName,
        avatarColor: state.user.avatarColor,
        isSending: state.post.isSending,
        // authToken: state.auth.authData.IdToken,
    }
};

export default connect(mapStateToProps, { })(CommentWriteScreen);
